import React, { useEffect } from 'react';
import { FaUser, FaUserTie, FaUsers, FaChevronRight, FaArrowLeft } from 'react-icons/fa';
import '../scss/ProfileSelection.scss';
import logo from '../images/logo-long.svg';

function ProfileSelection({ profiles, onSelectProfile, onClose }) {
  // Check if running on Android/Capacitor
  const isCapacitor = window.Capacitor?.isNativePlatform() || false;
  const isAndroid = isCapacitor && window.Capacitor?.getPlatform() === 'android';

  useEffect(() => {
    // Add Android class to body for CSS targeting
    if (isAndroid) {
      document.body.classList.add('android-device');
    }
    
    return () => {
      // Don't remove the class on unmount as other components might need it
      // The Header component will manage it when it mounts
    };
  }, [isAndroid]);
  const getIcon = (userType) => {
    switch (userType) {
      case 'parent':
        return <FaUsers className="profile-icon" />;
      case 'coach':
      case 'manager':
        return <FaUserTie className="profile-icon" />;
      default:
        return <FaUser className="profile-icon" />;
    }
  };

  const getRoleColor = (userType) => {
    switch (userType) {
      case 'parent':
        return 'parent';
      case 'coach':
      case 'manager':
        return 'coach';
      default:
        return 'player';
    }
  };

  const formatName = (profile) => {
    if (profile.first_name && profile.last_name) {
      const firstName = profile.first_name.charAt(0).toUpperCase() + profile.first_name.slice(1).toLowerCase();
      const lastName = profile.last_name.charAt(0).toUpperCase() + profile.last_name.slice(1).toLowerCase();
      return `${firstName} ${lastName}`;
    }
    // Fallback to display_name if first_name/last_name not available
    return profile.display_name || '';
  };

  return (
    <div className="ProfileSelection container">
      <header className="header">
        <div className="logo-container">
          <img 
            src={logo} 
            alt="Logo" 
            className="logo centered-logo" 
          />
        </div>
      </header>
      
      <div className="profile-selection-content">
        {onClose && (
          <button className="back-button" onClick={onClose}>
            <FaArrowLeft /> Back
          </button>
        )}
        <h1>Select Profile</h1>
        <p className="subtitle">We found multiple accounts. Which profile would you like to use?</p>
        
        <div className="profiles-list">
          {profiles.map((profile, index) => (
            <div 
              key={`${profile.user_type}-${profile.user_id}`}
              className={`profile-card profile-${getRoleColor(profile.user_type)}`}
              onClick={() => onSelectProfile(profile)}
            >
              <div className="profile-icon-wrapper">
                {getIcon(profile.user_type)}
              </div>
              <div className="profile-info">
                <h3>{formatName(profile)}</h3>
                <p className="profile-role">{profile.role}</p>
                {profile.shirt_number && (
                  <p className="profile-detail">Shirt # {profile.shirt_number}</p>
                )}
              </div>
              <div className="profile-arrow">
                <FaChevronRight />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProfileSelection;

